/** Tools executed on the server during prototyper streams — not client WebContainer tools. */
export const SERVER_EXECUTED_PROTOTYPER_TOOLS = ['readFile', 'searchFiles'] as const;

export type ServerExecutedPrototyperTool = (typeof SERVER_EXECUTED_PROTOTYPER_TOOLS)[number];

export function isServerExecutedPrototyperTool(toolName: string): toolName is ServerExecutedPrototyperTool {
  return (SERVER_EXECUTED_PROTOTYPER_TOOLS as readonly string[]).includes(toolName);
}

/** Resolve tool name from an assistant message part type (e.g. `tool-readFile`, `dynamic-tool`). */
export function toolNameFromPartType(type: string): string | undefined {
  if (type === 'dynamic-tool') return undefined;
  if (type.startsWith('tool-')) return type.slice('tool-'.length);
  return undefined;
}
